// extracted by mini-css-extract-plugin
module.exports = {"grid":"FullWidthTab_grid__2RPjJ","flex":"FullWidthTab_flex__QU100"};